import axios, { endpoints } from 'src/utils/axios';
// import { useRouter } from 'src/routes/hooks';
// import { useNavigate } from 'react-router';

// import { useRouter } from 'src/routes/hooks';
import { setSession } from './utils';
// import { STORAGE_KEY } from './constant';
// import { Navigate } from 'react-router';
// import { redirect } from 'react-router';

/** **************************************
 * Sign in
 *************************************** */

export const signIn = async ({ email, password, code }) => {
  const params = { email, password, code };
  const res = await axios.post(endpoints.auth.login, params);

  // const { access_token, refresh_token } = res.data;
  // if (!access_token) throw new Error('Access token not found in response');
  // if (!refresh_token) throw new Error('Refresh token not found in response');

  // setSession(access_token, refresh_token);
  return res.data;
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async (params) => {
  const res = await axios.post(endpoints.auth.register, params);
  return res.data;
};

/** **************************************
 * Update User
 *************************************** */
export const updateUser = async (params) => {
  const res = await axios.post(endpoints.auth.updateUser, params);
  return res.data;
};

/** **************************************
 * Delete User Profile Image
 *************************************** */
export const deleteUserProfileImage = async () => {
  const res = await axios.delete(endpoints.auth.deleteUserProfileImage);
  return res.data;
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async () => {
  try {
    setSession(null);
  } catch (error) {
    console.error('Error during sign-out: ', error);
    throw error;
  }
};

/** **************************************
 * Token Refresh
 *************************************** */

export const tokenRefresh = async (params) => {
  try {
    const res = await axios.post(endpoints.auth.refreshToken, params);

    const { access_token, refresh_token } = res.data;
    if (!access_token) throw new Error('Access token not found in response');
    if (!refresh_token) throw new Error('Refresh token not found in response');

    setSession(access_token, refresh_token);
    return res.data;
  } catch (error) {
    console.error('Error during sign-in: ', error);
    throw error;
  }
};

/** **************************************
 * Update New User
 *************************************** */
export const updateNewUser = async (params) => {
  const res = await axios.post(endpoints.auth.updateNewUser, params);
  return res.data;
};

/** **************************************
 * Change Password
 *************************************** */
export const changePassword = async ({ email, currentPassword, newPassword }) => {
  try {
    const params = { email, currentPassword, newPassword };

    const res = await axios.post(endpoints.auth.changePassword, params);

    const { access_token } = res.data;
    if (!access_token) {
      throw new Error('Access token not found in response');
    }

    setSession(access_token);
    return res.data;
  } catch (error) {
    console.error('Error during change password:', error);
    throw error;
  }
};

/** **************************************
 * Reset Password
 *************************************** */
export const resetPassword = async ({ email, password }) => {
  try {
    const params = { email, password };

    const res = await axios.post(endpoints.auth.resetPassword, params);

    return res.data;
  } catch (error) {
    console.error('Error during password reset:', error);
    throw error;
  }
};

/** **************************************
 * Password Recovery
 *************************************** */
export const passwordRecovery = async ({ email }) => {
  try {
    const params = { email };
    // console.info('Password Recovery data:', params);
    const res = await axios.post(endpoints.auth.passwordRecovery, params);

    return res.data;
  } catch (error) {
    console.error('Error during password reset:', error);
    throw error;
  }
};

/** **************************************
 * New Password
 *************************************** */
export const newPassword = async ({ userId, resetToken }) => {
  try {
    const res = await axios.post(`${endpoints.auth.newPassword}/${userId}/${resetToken}`);

    return res.data;
  } catch (error) {
    console.error('Error during password reset:', error);
    throw error;
  }
};

/** **************************************
 * New Password
 *************************************** */
export const updatePassword = async ({ token, email, password }) => {
  try {
    const params = {
      token,
      email,
      password,
    };

    console.info('Update password data:', params);

    const res = await axios.post(endpoints.auth.updatePassword, params);

    return res.data;
  } catch (error) {
    console.error('Error during password update:', error);
    throw error;
  }
};

/** **************************************
 * 2FA Management
 *************************************** */
export const get2FA = async ({ password }) => {
  const params = { password };
  const res = await axios.post(endpoints.auth.get2FA, params);
  return res.data;
};

export const enable2FA = async ({ code }) => {
  const params = { code };
  const res = await axios.post(endpoints.auth.enable2FA, params);
  return res.data;
};

export const disable2FA = async ({ password }) => {
  const params = { password };
  const res = await axios.post(endpoints.auth.disable2FA, params);
  return res.data;
};
